module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/6@2x_af40943b6052e50099f7a40ee068979c.png";